import { mainSiteUrl } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Artistic%20abstract%20arrangement%20of%20fashion%20and%20lifestyle%20products%20floating%20in%20soft%20dreamy%20composition%2C%20warm%20sand%20and%20terracotta%20color%20palette%2C%20ethereal%20natural%20light%2C%20editorial%20luxury%20ecommerce%20aesthetic%2C%20soft%20organic%20shapes%2C%20minimal%20elegant%20atmosphere&width=1800&height=1200&seq=hero-bg-v2&orientation=landscape')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50/80"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center flex flex-col items-center">
        <p className="text-xs md:text-sm font-medium text-white/70 tracking-[0.2em] uppercase mb-4 md:mb-6 whitespace-nowrap">
          Smart Product Sourcing System
        </p>
        <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.1] mb-6 md:mb-8 drop-shadow-lg">
          ItaobuySpreadsheet
          <br />
          <span className="text-white/80 font-normal">The Smart Way to Source</span>
        </h1>
        <p className="text-base md:text-lg text-white/70 max-w-2xl mb-8 md:mb-10 leading-relaxed">
          Discover how thousands of buyers use <strong className="text-white">itaobuyspreadsheet</strong> to find, compare, and purchase products faster, cheaper, and safer.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 text-sm font-semibold bg-white text-primary-500 rounded-full hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Start Using Itaobuy Spreadsheet
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="/#blog"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("blog")?.scrollIntoView({ behavior: "smooth" });
              window.history.replaceState(null, "", "/#blog");
            }}
            className="px-8 py-3.5 text-sm font-semibold border-2 border-white/60 text-white rounded-full hover:border-white hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Explore Product Sheets
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl text-white/50"></i>
      </div>
    </section>
  );
}